module.exports = __webpack_public_path__ + "cc108a5a5e2091fc543a940918f2eec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile24.png
// module id = 1885
// module chunks = 0